<script>
  import { onDestroy, onMount, tick } from "svelte"
  import { getNotificationsContext } from "svelte-notifications";
  import DialogBase2 from "../../../../../components/dialog/DialogBase2.svelte";
  import DialogTitle from "../../../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../../../components/dialog/DialogContent.svelte";
  import GeneralButton from "../../../../../components/button/GeneralButton.svelte";
  import SettingIconButton from "../../../../../components/IconButtons/SettingIconButton.svelte";
  import UploadDataDialog from "../../parts/UploadDataDialog.svelte";
  import ImportsTable from "../../../../parts/ImportsTable.svelte";
  import { constructImportsTableHeaders } from "../../../../parts/ImportsTableUtils.js";
  import { localizeTableData } from "../../importStep/parts/tableUtils.js";
  import { getAutoMpsProjectContext } from "../../../../AutoMpsProjectContext.js";


  export let selectedParametersDataId = "latest"

  export let onClose

  const {addNotification} = getNotificationsContext()
  const ctx = getAutoMpsProjectContext()

  let parameterDataImports = []
  async function getParameterDataImports() {
    const {imports} = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter`)
      .then(res => res.json())
    parameterDataImports = imports
  }
  $: if (selectedParametersDataId === "latest" && parameterDataImports && parameterDataImports.length > 0) {
    selectedParametersDataId = parameterDataImports[0].id
  }

  async function createNewManualImport(rows) {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter?useMappings=true`, {
      method: "POST",
      body: JSON.stringify({
        meta: {
          importMethod: "manual",
        },
        data: rows,
      }),
      headers: {
        "Content-Type": "application/json",
      }
    })
    if (!response.ok) {
      return addNotification({
        text: "ファイルのアップロードに失敗しました。",
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
    }

    addNotification({
      text: "ファイルをアップロードしました。",
      position: "top-right",
      removeAfter: 4000,
      type: "success",
    });

    // refresh the displayed data and select the newly uploaded data
    await getParameterDataImports()
    selectedParametersDataId = "latest"

    isUploadDataDialogOpen = false
  }

  let isUploadDataDialogOpen = false

  let dialog
  onMount(async () => {
    await tick()
    dialog.showModal()
    await getParameterDataImports()
  })
  onDestroy(() => dialog.close())

  $: console.log(parameterDataImports)
</script>

<DialogBase2 bind:dialog={dialog} width="750px">
  <DialogTitle onClickClose={onClose}>
    使用する平準化パラメタを選択する
  </DialogTitle>
  <DialogSplitter />
  <DialogContent>
    <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 1rem;">
      <div>使用するデータを設定します。</div>
      <div style="display: inline-flex; gap: .5rem">
        <GeneralButton onClick={() => isUploadDataDialogOpen = true}>
          新しいインポートを作成する
        </GeneralButton>
        <SettingIconButton />
      </div>
    </div>
    <ImportsTable
      bind:selectedRowId={selectedParametersDataId}
      dataType="parameter"
      headers={constructImportsTableHeaders({insertRadio: true, insertViewImportButton: true})}
      rows={localizeTableData(parameterDataImports)}
    />
  </DialogContent>
</DialogBase2>
{#if isUploadDataDialogOpen}
  <UploadDataDialog
    onClickUpload={rows => createNewManualImport(rows)}
    onClose={() => isUploadDataDialogOpen = false}
  />
{/if}
